// useExtensionVersion - Version der CI/CD-Erweiterung im Repository des Space (Marker aus /api/cicd/extension-status).
// Einmal je Space und Aufruf von Schritt 5, nur wenn `spaceId` gesetzt ist; der Aufrufer übergibt null, solange er die
// Version nicht braucht, denn der Endpunkt liest GitHub. Unbekannt (nicht gebunden, Lesefehler, kein Marker) ist null.
import { useEffect, useState } from "react";
import { api } from "../../../utils/helpers";

export default function useExtensionVersion(spaceId) {
  const [state, setState] = useState({ spaceId: null, version: null });

  useEffect(() => {
    if (!spaceId) return undefined;
    let alive = true;
    const controller = new AbortController();
    api(`/api/cicd/extension-status?spaceId=${encodeURIComponent(spaceId)}`, { signal: controller.signal, retry: false })
      .then(r => {
        const version = typeof r?.version === "number" || typeof r?.version === "string" ? Number(r.version) : NaN;
        if (alive) setState({ spaceId, version: Number.isFinite(version) ? version : null });
      })
      .catch(() => { if (alive) setState({ spaceId, version: null }); });
    return () => { alive = false; controller.abort(); };
  }, [spaceId]);

  // Ein Ergebnis gilt nur für den Space, für den es geladen wurde.
  return state.spaceId === spaceId ? state.version : null;
}
